var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        visible: "",
        size: _vm.size,
        title: _vm.title,
        centered: _vm.centered,
        "hide-footer": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": !_vm.closeOnEscape || !_vm.closable
      },
      on: {
        ok: function($event) {
          return _vm.$emit("ok")
        },
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function() {
            return [
              _c("h4", { staticClass: "modal-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                !_vm.hideClose && _vm.closable
                  ? _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.onClose.apply(null, arguments)
                          }
                        }
                      },
                      [_c("Icon", { attrs: { icon: "close" } })],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.subTitle
                ? _c("div", { staticClass: "modal-sub-title" }, [
                    _vm._v(_vm._s(_vm.subTitle))
                  ])
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      !_vm.hideActions
        ? _c("div", { staticClass: "actions" }, [
            !_vm.hideCancel && _vm.closable
              ? _c("div", { class: { "mt-2 mt-md-0 mr-md-4": !_vm.hideOk } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.$emit("hidden")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.cancelText))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.hideOk
              ? _c(
                  "div",
                  [
                    _c("Button", {
                      attrs: {
                        text: _vm.okText,
                        disabled: _vm.okDisabled,
                        loading: _vm.okLoading,
                        icon: _vm.okIcon
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("ok")
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }